module.exports = __webpack_public_path__ + "static/media/14.719becf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/14.jpg
// module id = 189
// module chunks = 0